import { createAction, props } from '@ngrx/store';
import { IGroupedProducts } from '../models/products.model';

export const loadGroupedProductsFromSomeoneElse = createAction(
  '[GroupedProductsFromSomeoneElse] Load GroupedProductsFromSomeoneElse',
  props<{ request: string }>()
);

export const loadGroupedProductsFromSomeoneElseSuccess = createAction(
  '[GroupedProductsFromSomeoneElse] Load GroupedProductsFromSomeoneElse Success',
  props<{ response: IGroupedProducts[] }>()
);

export const loadGroupedProductsFromSomeoneElseFailure = createAction(
  '[GroupedProductsFromSomeoneElse] Load GroupedProductsFromSomeoneElse Failure',
  props<{ error: Error | any }>()
);
